(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["m-premium-motion"] && !Shopify.designMode) return;
  try {
    (() => {
  if (document.documentElement.dataset.arteScrollMotion) return;
  document.documentElement.dataset.arteScrollMotion = 'ready';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = matchMedia('(min-width: 750px) and (pointer: fine)');
  const visibleArt = new Set();
  const pending = new Map();
  const active = new Set();
  const seen = new WeakSet();
  const header = document.querySelector('.m-header');
  const candidates = [
    '[data-m-reveal]', '.m-heading-row', '.v3-evidence-heading',
    '.v3-routine-heading', '.v3-nad-heading', '.v3-nj-header',
    '.m-approach-section-heading', '.m-faq-grid>div:first-child',
    '.m-card', '.m-value', '.m-category', '.m-editorial-copy',
    '.m-brand-statement', '.m-quality-inner>div', '.m-label-heading',
    '.m-label-table-wrap', '.m-label-detail-grid>article',
    '.v3-evidence-tabs', '.v3-evidence-panels', '.v3-routine-tabs',
    '.v3-routine-panels', '.v3-overview-glass', '.v3-nad-tabs',
    '.v3-nad-card', '.v3-nj-rail', '.v3-nj-details',
    '.m-approach-formula', '.m-approach-pillars>article', '.m-approach-origin',
    '.v3-blog-card', '.v3-journal-card', '.v3-compare-card', '.v2-science-card',
    '.m-faq-list>details', '.m-newsletter', '.m-footer-grid>div',
    '.m-footer-grid>nav', '.m-rte>p', '.m-rte>h2', '.m-rte>h3',
    '.m-rte>ul', '.m-rte>ol', '.contact',
    '#MainContent .m-section>h2', '#MainContent .m-section>p'
  ].join(',');
  const excluded = '.v2-hero,.m-purchase,.v2-buy-form,.v2-sticky-buy,.v3-cart-dialog,dialog,.m-header,[aria-live],[role="status"],[data-scroll-reveal="off"]';
  let revealObserver, parallaxObserver, frame;
  function track(animation) {
    active.add(animation);
    animation.finished.then(() => {
      active.delete(animation);
      animation.cancel();
    }, () => active.delete(animation));
    return animation;
  }
  function splitHeading(heading) {
    if (heading.querySelector('.arte-reveal-word')) return [...heading.querySelectorAll('.arte-reveal-word')];
    const walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (node.parentElement.closest('a,button,svg,[aria-hidden="true"],.visually-hidden')) continue;
      if (node.textContent.trim()) nodes.push(node);
    }
    const words = [];
    nodes.forEach(node => {
      const fragment = document.createDocumentFragment();
      node.textContent.split(/(\s+)/).forEach(part => {
        if (!part) return;
        if (/^\s+$/.test(part)) fragment.append(document.createTextNode(part));
        else {
          const word = document.createElement('span');
          word.className = 'arte-reveal-word';
          word.textContent = part;
          fragment.append(word);
          words.push(word);
        }
      });
      node.replaceWith(fragment);
    });
    return words;
  }
  function finishElement(element) {
    const record = pending.get(element);
    if (record) {
      record.animation.cancel();
      pending.delete(element);
      revealObserver?.unobserve(element);
    }
    active.forEach(animation => {
      const target = animation.effect?.target;
      if (target === element || element.contains(target)) animation.cancel();
    });
    element.dataset.arteReveal = 'visible';
  }
  function reveal(element, instant = false) {
    const record = pending.get(element);
    if (!record) return;
    pending.delete(element);
    revealObserver?.unobserve(element);
    element.dataset.arteReveal = 'visible';
    if (instant || reduced.matches || document.hidden) {
      record.animation.cancel();
      return;
    }
    record.animation.play();
    const headings = element.matches('h2') ? [element] : [...element.querySelectorAll('h2')];
    headings.forEach(heading => {
      const words = splitHeading(heading);
      const step = Math.min(55, 650 / Math.max(1, words.length));
      words.forEach((word, index) => track(word.animate(
        [{opacity: .08}, {opacity: 1}],
        {duration: 440, delay: record.delay + index * step, easing: 'ease-out', fill: 'both'}
      )));
    });
  }
  function revealVisible(instant = false) {
    const visible = [];
    pending.forEach((record, element) => {
      const rect = element.getBoundingClientRect();
      if (rect.top < innerHeight && rect.bottom > 0 && rect.width > 0) visible.push(element);
    });
    visible.forEach(element => reveal(element, instant));
  }
  function tick() {
    frame = null;
    const scrolled = String(scrollY > 30);
    const height = innerHeight;
    const updates = reduced.matches || !desktop.matches ? [] : [...visibleArt].filter(el => el.isConnected).map(el => {
      const rect = el.getBoundingClientRect();
      const amount = Math.max(-1, Math.min(1, (height / 2 - rect.top - rect.height / 2) / height));
      return [el, amount * 18];
    });
    if (header && header.dataset.scrolled !== scrolled) header.dataset.scrolled = scrolled;
    updates.forEach(([el, amount]) => {
      const value = amount.toFixed(2) + 'px';
      if (el.style.getPropertyValue('--m-parallax-y') !== value) el.style.setProperty('--m-parallax-y', value);
    });
  }
  function schedule() {
    const updateHeader = header && header.dataset.scrolled !== String(scrollY > 30);
    const updateParallax = !reduced.matches && desktop.matches && visibleArt.size > 0;
    if (!frame && (updateHeader || updateParallax)) frame = requestAnimationFrame(tick);
  }
  function init(root = document) {
    if (!('IntersectionObserver' in window) || !Element.prototype.animate) return;
    try {
      if (!revealObserver) revealObserver = new IntersectionObserver(entries => {
        entries.filter(entry => entry.isIntersecting).forEach(entry => reveal(entry.target));
      }, {threshold: 0, rootMargin: '0px 0px -3% 0px'});
      if (!parallaxObserver) parallaxObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => entry.isIntersecting ? visibleArt.add(entry.target) : visibleArt.delete(entry.target));
        schedule();
      }, {rootMargin: '80px'});
      const elements = [...root.querySelectorAll(candidates)].filter(el => {
        if (el.closest(excluded) || seen.has(el)) return false;
        const ancestor = el.parentElement?.closest(candidates);
        return !ancestor || !root.contains(ancestor);
      });
      const measured = elements.filter(element => element.closest('#MainContent,.m-footer')).map(element => ({ element, rect: element.getBoundingClientRect() }));
      let previousTop = -Infinity, column = 0;
      measured.forEach(({ element, rect }) => {
        if (!rect.width || !rect.height) return;
        seen.add(element);
        if (reduced.matches || window.Shopify?.designMode || rect.top < innerHeight || document.hidden) {
          element.dataset.arteReveal = 'visible';
          return;
        }
        column = Math.abs(rect.top - previousTop) < 24 ? column + 1 : 0;
        previousTop = rect.top;
        const delay = Math.min(column * 70, 210);
        const animation = track(element.animate(
          [{opacity: .001, transform: 'translateY(18px)'}, {opacity: 1, transform: 'translateY(0)'}],
          {duration: 850, delay, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'both'}
        ));
        animation.pause();
        animation.currentTime = 0;
        element.dataset.arteReveal = 'pending';
        pending.set(element, {animation, delay});
        revealObserver.observe(element);
      });
      root.querySelectorAll('[data-m-parallax]').forEach(el => parallaxObserver.observe(el));
      schedule();
    } catch {
      pending.forEach((record, element) => finishElement(element));
      active.forEach(animation => animation.cancel());
    }
  }
  addEventListener('scroll', schedule, {passive: true});
  addEventListener('resize', () => { schedule(); revealVisible(); }, {passive: true});
  addEventListener('pageshow', () => revealVisible(true));
  addEventListener('hashchange', () => revealVisible(true));
  addEventListener('beforeprint', () => {
    pending.forEach((record, element) => finishElement(element));
    active.forEach(animation => animation.cancel());
  });
  document.addEventListener('focusin', event => {
    const element = event.target.closest?.('[data-arte-reveal]');
    if (element) finishElement(element);
  });
  reduced.addEventListener('change', () => {
    if (reduced.matches) {
      pending.forEach((record, element) => finishElement(element));
      active.forEach(animation => animation.cancel());
    }
    document.querySelectorAll('[data-m-parallax]').forEach(el => el.style.removeProperty('--m-parallax-y'));
    schedule();
  });
  desktop.addEventListener('change', () => {
    if (!desktop.matches) visibleArt.forEach(el => el.style.removeProperty('--m-parallax-y'));
    schedule();
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    pending.forEach((record, element) => { if (event.target.contains(element)) finishElement(element); });
    event.target.querySelectorAll('[data-m-parallax]').forEach(el => { visibleArt.delete(el); parallaxObserver?.unobserve(el); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once: true});
  else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["v2-purchase"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('arte-purchase'))customElements.define('arte-purchase',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  const form=this.querySelector('form'),buttons=[...this.querySelectorAll('[data-v2-add]')],status=this.querySelector('.v2-buy-status'),check=this.querySelector('.v2-check-cart'),quantity=this.querySelector('[name="quantity"]'),sticky=this.querySelector('.v2-sticky-buy');
  this.querySelector('[data-v2-variant]')?.addEventListener('change',event=>{const url=new URL(window.location.href);url.searchParams.set('variant',event.target.value);window.location.assign(url.href)});
  const setStatus=(message,state='pending')=>{status.dataset.state=message?state:'idle';status.querySelector('[data-status-text]').textContent=message;status.querySelector('[data-status-check]').toggleAttribute('hidden',state!=='success')};
  const quantitySteps=[...this.querySelectorAll('[data-quantity-step]')],quantityLabel=this.querySelector('[data-v2-quantity]'),priceLabels=[...this.querySelectorAll('[data-v3-purchase-price]')];
  if(sticky){
   this.sticky=sticky;(this.closest('.v3-product')||document.body).append(sticky);
   const cartButton=sticky.querySelector('[data-sticky-cart]'),cartCount=sticky.querySelector('[data-sticky-cart-count]'),cartLabel=sticky.querySelector('[data-sticky-cart-label]');
   const changeCartLabel=text=>{
    if(cartLabel.textContent===text)return;
    this.cartLabelMotion?.cancel();cartLabel.textContent=text;
    if(!matchMedia('(prefers-reduced-motion:reduce)').matches&&cartLabel.animate)this.cartLabelMotion=cartLabel.animate([{opacity:.2,transform:'translateY(3px)'},{opacity:1,transform:'translateY(0)'}],{duration:260,easing:'ease-out'});
   };
   const resetCartFeedback=()=>{clearTimeout(this.cartFeedbackTimer);cartButton.classList.remove('is-empty-feedback');changeCartLabel(cartButton.dataset.label)};
   this.syncStickyCart=()=>{
    const count=Number(document.querySelector('arte-cart-drawer .v3-cart-content')?.dataset.count??sticky.dataset.cartCount)||0;
    sticky.dataset.cartCount=String(count);cartButton.classList.toggle('has-items',count>0);cartCount.textContent=String(count);cartCount.hidden=count===0;
    if(count>0)resetCartFeedback();
    cartButton.setAttribute('aria-label',(cartButton.classList.contains('is-empty-feedback')?cartButton.dataset.emptyLabel:cartButton.dataset.label)+(count>0?' ('+count+')':''));
   };
   document.addEventListener('arte:cart-updated',this.syncStickyCart);this.syncStickyCart();
   cartButton.addEventListener('click',event=>{
    this.syncStickyCart();
    if(Number(sticky.dataset.cartCount)===0){
     event.preventDefault();clearTimeout(this.cartFeedbackTimer);cartButton.classList.add('is-empty-feedback');changeCartLabel(cartButton.dataset.emptyLabel);cartButton.setAttribute('aria-label',cartButton.dataset.emptyLabel);
     this.cartWarningMotion?.cancel();
     if(!matchMedia('(prefers-reduced-motion:reduce)').matches&&cartButton.animate)this.cartWarningMotion=cartButton.animate([{boxShadow:'0 0 0 0 #d88e8133'},{boxShadow:'0 0 0 7px #d88e8129',offset:.4},{boxShadow:'0 0 0 12px #d88e8100'}],{duration:750,easing:'ease-out'});
     this.cartFeedbackTimer=setTimeout(()=>{resetCartFeedback();this.syncStickyCart()},2800);return;
    }
    const drawer=document.querySelector('arte-cart-drawer');if(drawer?.open){event.preventDefault();drawer.open(cartButton)}
   });
  }
  const syncQuantity=()=>{if(quantityLabel)quantityLabel.textContent=quantity.value||'1';quantitySteps.forEach(button=>{button.hidden=Number(button.dataset.quantityStep)<0&&(quantity.valueAsNumber<2||!Number.isFinite(quantity.valueAsNumber))})};
  quantity.addEventListener('input',syncQuantity);quantity.addEventListener('change',syncQuantity);
  quantitySteps.forEach(button=>button.addEventListener('click',()=>{if(Number(button.dataset.quantityStep)>0)quantity.stepUp();else quantity.stepDown();quantity.dispatchEvent(new Event('input',{bubbles:true}));this.animateQuantity(quantity,Number(button.dataset.quantityStep));if(button.hidden)quantity.focus()}));syncQuantity();
  const frequency=form.querySelector('[data-subscription-frequency]'),modes=[...form.querySelectorAll('[name="purchase_option"]')];
  const syncPlanPrice=()=>{
   if(!frequency)return;
   const mode=form.querySelector('[name="purchase_option"]:checked'),option=frequency.selectedOptions[0],subscribing=mode?.value==='subscription';
   frequency.disabled=!subscribing;
   const price=subscribing?option?.dataset.planPrice:mode?.dataset.planPrice;
   if(price)priceLabels.forEach(label=>this.animatePrice(label,price,subscribing));
   this.syncFormatPrices(subscribing,option?.dataset.frequencyValue,option?.value);
   const subPrice=form.querySelector('[data-subscription-price]'),discount=form.querySelector('[data-subscription-discount]');
   if(subPrice&&option?.dataset.planPrice)subPrice.textContent=option.dataset.planPrice;
   if(discount&&option){const amount=Number(option.dataset.discount)||0;discount.hidden=amount<=0;discount.textContent='−'+amount+' %'}
  };
  if(frequency){const single=frequency.querySelector('[data-one-time-option]');if(single)single.hidden=true;frequency.addEventListener('change',syncPlanPrice)}
  modes.forEach(mode=>mode.addEventListener('change',syncPlanPrice));syncPlanPrice();
  form.addEventListener('submit',async event=>{
   event.preventDefault();if(this.dataset.available!=='true'||this.busy||!form.reportValidity())return;this.busy=true;
   buttons.forEach(button=>button.disabled=true);form.setAttribute('aria-busy','true');setStatus(this.dataset.pending);check.hidden=true;
   try{
    const drawer=document.querySelector('arte-cart-drawer'),payload=new FormData(form);if(!payload.get('selling_plan'))payload.delete('selling_plan');if(drawer?.renderCart){payload.append('sections',drawer.dataset.section);payload.append('sections_url',location.pathname)}
    const response=await fetch(this.dataset.add,{method:'POST',headers:{Accept:'application/json'},body:payload});
    const result=await response.json();
    if(!response.ok){setStatus(typeof result.description==='string'?result.description:this.dataset.error,'error');return}
    if(drawer?.renderCart&&drawer.renderCart(result.sections)){setStatus(this.dataset.success,'success');await drawer.open(event.submitter||buttons[0]);drawer.status(this.dataset.success,false,'success')}else{window.location.assign(this.dataset.cart)}
   }catch{setStatus(this.dataset.error,'error');check.hidden=false}
   finally{this.busy=false;form.removeAttribute('aria-busy');buttons.forEach(button=>button.disabled=this.dataset.available!=='true')}
  });
  if(sticky){this.updateSticky=()=>{if(this.stickyFrame)return;this.stickyFrame=requestAnimationFrame(()=>{this.stickyFrame=0;const show=form.getBoundingClientRect().bottom<0;sticky.hidden=!show;document.body.classList.toggle('v2-sticky-active',show)})};window.addEventListener('scroll',this.updateSticky,{passive:true});window.addEventListener('resize',this.updateSticky);this.updateSticky()}
 }
 syncFormatPrices(subscribing,frequencyValue,planId){
  const scope=this.closest('.v3-product');if(!scope)return;
  scope.querySelectorAll('[data-v3-format-card]').forEach(card=>{
   let plans=[];try{plans=JSON.parse(card.dataset.formatPlans||'[]')}catch{}
   const plan=subscribing?(plans.find(item=>String(item.id)===String(planId))||plans.find(item=>item.frequency===frequencyValue)||plans.find(item=>String(item.id)===card.dataset.formatDefaultPlan)||plans[0]):null;
   const price=plan?.price||card.dataset.formatOneTime,label=plan?.label||card.dataset.formatOneTimeLabel,node=card.querySelector('.v3-format-price');
   if(node&&price)this.animatePrice(node,price,Boolean(plan));
   if(label)card.setAttribute('aria-label',label);
  });
 }
 animateQuantity(input,direction){
  this.quantityMotion?.cancel();if(matchMedia('(prefers-reduced-motion:reduce)').matches||!input.animate)return;
  const base=getComputedStyle(input),color=base.color,background=base.backgroundColor,positive=direction>0;
  this.quantityMotion=input.animate([{color:positive?'#29884a':'#b85d58',backgroundColor:positive?'#e4f4dc':'#fae9e7',opacity:.45,transform:'translateY('+(positive?4:-4)+'px) scale(.97)'},{color:positive?'#29884a':'#b85d58',backgroundColor:positive?'#e4f4dc':'#fae9e7',opacity:1,transform:'translateY(0) scale(1.045)',offset:.35},{color,backgroundColor:background,opacity:1,transform:'translateY(0) scale(1)'}],{duration:420,easing:'cubic-bezier(.2,.7,.2,1)'});
 }
 animatePrice(label,next,subscribing=false){
  this.priceMotions??=new Map();
  const previous=this.priceMotions.get(label);
  if(previous?.next===next)return;
  previous?.animation.cancel();this.priceMotions.delete(label);
  if(label.textContent===next)return;
  if(!label.animate||matchMedia('(prefers-reduced-motion:reduce)').matches){label.textContent=next;return}
  const baseColor=getComputedStyle(label).color,transitionColor=subscribing?'#27834a':baseColor;
  const entry={next,animation:label.animate([{opacity:1,color:baseColor,transform:'translateY(0)',filter:'blur(0)'},{opacity:0,color:transitionColor,transform:'translateY(-5px)',filter:'blur(2px)'}],{duration:110,easing:'ease-in',fill:'forwards'})};
  this.priceMotions.set(label,entry);
  entry.animation.finished.then(()=>{
   if(this.priceMotions.get(label)!==entry)return;
   entry.animation.cancel();label.textContent=next;
   entry.animation=label.animate([{opacity:0,color:transitionColor,transform:'translateY(5px)',filter:'blur(2px)'},{opacity:1,color:transitionColor,transform:'translateY(0)',filter:'blur(0)',offset:.45},{opacity:1,color:baseColor,transform:'translateY(0)',filter:'blur(0)'}],{duration:subscribing?520:300,easing:'cubic-bezier(.2,.7,.2,1)'});
   entry.animation.finished.then(()=>{if(this.priceMotions.get(label)===entry)this.priceMotions.delete(label)}).catch(()=>{});
  }).catch(()=>{});
 }
 disconnectedCallback(){clearTimeout(this.cartFeedbackTimer);this.cartLabelMotion?.cancel();this.cartWarningMotion?.cancel();this.quantityMotion?.cancel();if(this.syncStickyCart)document.removeEventListener('arte:cart-updated',this.syncStickyCart);this.sticky?.remove();this.priceMotions?.forEach(entry=>entry.animation.cancel());this.priceMotions?.clear();if(this.updateSticky){window.removeEventListener('scroll',this.updateSticky);window.removeEventListener('resize',this.updateSticky)}if(this.stickyFrame)cancelAnimationFrame(this.stickyFrame);document.body.classList.remove('v2-sticky-active')}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["v3-card-quick-add"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('arte-card-quick-add'))customElements.define('arte-card-quick-add',class extends HTMLElement{
  static queue=Promise.resolve();
  connectedCallback(){
    if(this.controller)return;
    this.controller=new AbortController();
    this.form=this.querySelector('form');this.button=this.querySelector('button[type=submit]');this.status=this.querySelector('[data-quick-status]');this.recover=this.querySelector('[data-quick-recover]');
    if(!this.form||!this.button)return;
    this.form.addEventListener('submit',event=>{
      event.preventDefault();
      if(this.busy||this.button.disabled||!this.form.reportValidity())return;
      this.busy=true;this.button.disabled=true;this.form.setAttribute('aria-busy','true');this.setStatus(this.dataset.pending,'pending');
      this.constructor.queue=this.constructor.queue.catch(()=>{}).then(()=>this.add());
    },{signal:this.controller.signal});
  }
  setStatus(message,state){this.form.dataset.state=state;this.status.textContent=message;this.recover.hidden=state!=='error'}
  async add(){
    let added=false;
    try{
      const drawer=document.querySelector('arte-cart-drawer'),payload=new FormData(this.form);
      payload.delete('selling_plan');payload.delete('purchase_option');
      const page=document.querySelector('[data-cart-section]');
      if(drawer?.renderCart){payload.set('sections',[drawer.dataset.section,page?.dataset.cartSection].filter(Boolean).join(','));payload.set('sections_url',location.pathname)}
      const response=await fetch(this.dataset.add,{method:'POST',headers:{Accept:'application/json'},body:payload});
      const result=await response.json();
      if(!response.ok){this.setStatus(typeof result.description==='string'?result.description:this.dataset.error,'error');return}
      added=true;this.setStatus(this.dataset.success,'success');
      customElements.get('arte-cart-page')?.renderSections(result.sections);
      if(drawer?.renderCart&&drawer.renderCart(result.sections)){
        if(!drawer.dialog?.open)await drawer.open(this.button.isConnected?this.button:document.querySelector('[data-v3-cart-open]'));else drawer.querySelector('[data-v3-close]')?.focus({preventScroll:true});drawer.status(this.dataset.success,false,'success');
      }else{window.location.assign(this.dataset.cart)}
    }catch{
      if(added){window.location.assign(this.dataset.cart)}else{this.setStatus(this.dataset.error,'error')}
    }finally{this.busy=false;this.button.disabled=false;this.form.removeAttribute('aria-busy')}
  }
  disconnectedCallback(){this.controller?.abort();this.controller=null}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["v3-hero-video"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('arte-hero-video'))customElements.define('arte-hero-video',class extends HTMLElement{
  connectedCallback(){
    if(this.abort)return;
    this.abort=new AbortController();const options={signal:this.abort.signal};
    this.video=this.querySelector('video');
    if(!this.video)return;
    this.reduced=matchMedia('(prefers-reduced-motion:reduce)');this.inView=true;
    this.video.muted=true;this.video.playsInline=true;
    const sync=()=>{if(document.hidden||!this.inView||this.reduced.matches)this.video.pause();else this.video.play().catch(()=>{})};
    document.addEventListener('visibilitychange',sync,options);
    this.reduced.addEventListener('change',sync,options);
    if('IntersectionObserver' in window){this.observer=new IntersectionObserver(entries=>{this.inView=entries[0].isIntersecting;sync()},{threshold:.05});this.observer.observe(this)}
    sync();
  }
  disconnectedCallback(){this.abort?.abort();this.abort=null;this.observer?.disconnect();this.video?.pause()}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["v3-hero-words"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('arte-hero-words'))customElements.define('arte-hero-words',class extends HTMLElement{
  connectedCallback(){
    if(this.controller)return;
    this.controller=new AbortController();
    const signal=this.controller.signal;
    this.words=[...this.querySelectorAll('[data-hero-word]')];
    this.heading=this.closest('h1');
    this.group=this.closest('.v3-hero-heading-group');
    this.prefixNode=this.querySelector('[data-hero-prefix]');
    this.motion=matchMedia('(prefers-reduced-motion: reduce)');
    this.index=0;this.visible=false;this.timer=null;
    this.show(0);this.fit(true);
    this.motion.addEventListener('change',()=>{if(this.motion.matches)this.show(0);this.refresh()},{signal});
    document.addEventListener('visibilitychange',()=>this.refresh(),{signal});
    this.observer=new IntersectionObserver(entries=>{this.visible=entries.some(entry=>entry.isIntersecting);this.refresh()},{threshold:.15});
    this.observer.observe(this);
    this.resize=new ResizeObserver(()=>this.fit(false));
    this.resize.observe(this.group);
    document.fonts.ready.then(()=>{if(this.isConnected&&this.controller)this.fit(true)});
    this.refresh();
  }
  disconnectedCallback(){
    clearTimeout(this.timer);this.observer?.disconnect();this.resize?.disconnect();this.controller?.abort();this.controller=null;
  }
  fit(force){
    const available=this.group.clientWidth;
    if(!force&&available===this.previousWidth)return;
    this.previousWidth=available;
    this.heading.style.removeProperty('--v3-hero-title-size');
    const stack=this.querySelector('.v3-hero-first-line');
    for(let attempt=0;attempt<3;attempt++){
      const required=stack.getBoundingClientRect().width;
      if(available<=0||required<=available-2)break;
      const current=parseFloat(getComputedStyle(this.heading).fontSize);
      this.heading.style.setProperty('--v3-hero-title-size',Math.floor(current*(available-2)/required*10)/10+'px');
    }
  }
  show(index){
    this.index=index;this.dataset.heroIndex=String(index);
    const prefix=this.words[index].dataset.prefix;
    if(this.prefixNode.textContent!==prefix)this.prefixNode.textContent=prefix;
    this.words.forEach((word,i)=>word.toggleAttribute('data-active',i===index));
  }
  refresh(){
    clearTimeout(this.timer);
    if(this.motion.matches||document.hidden||!this.visible)return;
    this.timer=setTimeout(()=>{this.show((this.index+1)%this.words.length);this.refresh()},2800);
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["v3-language-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit',event=>{
  const form=event.target;
  if(!form.matches?.('[data-v3-language] form'))return;
  const languageCountry=event.submitter?.dataset.hxLanguageCountry;
  const country=form.querySelector('input[name="country_code"]');
  if(languageCountry&&country)country.value=languageCountry;
  const destination=form.querySelector('input[name="return_to"]');
  if(!destination)return;
  const target=new URL(destination.value,location.origin);
  const current=new URL(location.href);
  for(const key of ['variant','selling_plan','purchase_option']){
    if(current.searchParams.has(key))target.searchParams.set(key,current.searchParams.get(key));
    else target.searchParams.delete(key);
  }
  target.hash=current.hash;
  destination.value=target.pathname+target.search+target.hash;
},true);
document.addEventListener('toggle',event=>{
  if(event.target.matches?.('[data-v3-language]')&&!event.target.open){
    const more=event.target.querySelector('.v3-language-more');
    if(more)more.open=false;
  }
},true);
document.addEventListener('click',event=>{
  document.querySelectorAll('[data-v3-language][open]').forEach(selector=>{
    if(!selector.contains(event.target))selector.open=false;
  });
});
document.addEventListener('keydown',event=>{
  if(event.key!=='Escape')return;
  document.querySelectorAll('[data-v3-language][open]').forEach(selector=>{
    selector.open=false;selector.querySelector('summary').focus();
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["v3-nad-explained"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('arte-nad-journey')){
  customElements.define('arte-nad-journey',class extends HTMLElement{
    connectedCallback(){
      if(this.abort)return;
      this.abort=new AbortController();
      const options={signal:this.abort.signal};
      this.rail=this.querySelector('.v3-nj-rail');
      this.cards=[...this.querySelectorAll('[data-nj-index]')];
      this.panels=[...this.querySelectorAll('.v3-nj-panel')];
      this.progress=[...this.querySelectorAll('.v3-nj-progress span')];
      this.previous=this.querySelector('[data-nj-prev]');
      this.next=this.querySelector('[data-nj-next]');
      this.counter=this.querySelector('[data-nj-count]');
      this.mobile=window.matchMedia('(max-width:989px)');
      this.reduced=window.matchMedia('(prefers-reduced-motion:reduce)');
      this.index=0;
      this.cards.forEach((card,index)=>{
        card.addEventListener('click',()=>this.select(index,{scroll:true}),options);
        card.addEventListener('keydown',event=>{
          let next=index;
          if(event.key==='ArrowRight')next=Math.min(index+1,this.cards.length-1);
          else if(event.key==='ArrowLeft')next=Math.max(index-1,0);
          else if(event.key==='Home')next=0;
          else if(event.key==='End')next=this.cards.length-1;
          else return;
          event.preventDefault();
          this.select(next,{scroll:true,focus:true});
        },options);
      });
      this.previous.addEventListener('click',()=>this.select(this.index-1,{scroll:true}),options);
      this.next.addEventListener('click',()=>this.select(this.index+1,{scroll:true}),options);
      this.rail.addEventListener('scroll',()=>{
        if(!this.mobile.matches)return;
        clearTimeout(this.scrollTimer);
        this.scrollTimer=setTimeout(()=>this.syncScroll(),140);
      },{...options,passive:true});
      this.mobile.addEventListener('change',()=>{
        this.programmatic=false;
        clearTimeout(this.releaseTimer);
        if(this.mobile.matches)this.scrollToCard(this.index,true);
      },options);
      this.classList.add('is-ready');
    }
    select(index,{scroll=false,focus=false}={}){
      index=Math.max(0,Math.min(this.cards.length-1,index));
      const changed=index!==this.index;
      this.index=index;
      this.cards.forEach((card,i)=>{
        const active=i===index;
        card.classList.toggle('is-active',active);
        card.setAttribute('aria-selected',String(active));
        card.tabIndex=active?0:-1;
        this.panels[i].hidden=!active;
        this.panels[i].classList.toggle('is-entering',active&&changed);
        this.progress[i].classList.toggle('is-active',active);
      });
      this.counter.textContent=String(index+1).padStart(2,'0');
      this.previous.disabled=index===0;
      this.next.disabled=index===this.cards.length-1;
      if(scroll&&this.mobile.matches)this.scrollToCard(index);
      if(focus)this.cards[index].focus({preventScroll:true});
    }
    scrollToCard(index,instant=false){
      clearTimeout(this.releaseTimer);
      this.programmatic=true;
      const target=this.cards[index];
      const left=target.getBoundingClientRect().left-this.rail.getBoundingClientRect().left+this.rail.scrollLeft-2;
      this.rail.scrollTo({left,behavior:this.reduced.matches||instant?'instant':'smooth'});
      this.releaseTimer=setTimeout(()=>{this.programmatic=false;this.syncScroll()},750);
    }
    syncScroll(){
      if(this.programmatic||!this.mobile.matches)return;
      const start=this.rail.getBoundingClientRect().left;
      let closest=0;
      let distance=Infinity;
      this.cards.forEach((card,index)=>{
        const current=Math.abs(card.getBoundingClientRect().left-start);
        if(current<distance){distance=current;closest=index;}
      });
      if(closest!==this.index)this.select(closest);
    }
    disconnectedCallback(){
      this.abort?.abort();
      this.abort=null;
      clearTimeout(this.scrollTimer);
      clearTimeout(this.releaseTimer);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["v3-nad-timeline-content"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('arte-nad-timeline'))customElements.define('arte-nad-timeline',class extends HTMLElement{
  connectedCallback(){
    if(this.controller)return;
    this.controller=new AbortController();const signal=this.controller.signal;
    this.tabs=[...this.querySelectorAll('[data-view]')];this.panels=[...this.querySelectorAll('[data-panel]')];
    this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.animations=[];this.frame=null;this.day=56;
    this.tabs.forEach((tab,index)=>{
      tab.addEventListener('click',()=>this.select(tab.dataset.view,true),{signal});
      tab.addEventListener('keydown',event=>{let next;if(event.key==='ArrowRight'||event.key==='ArrowLeft')next=1-index;if(event.key==='Home')next=0;if(event.key==='End')next=1;if(next!==undefined){event.preventDefault();this.tabs[next].focus();this.select(this.tabs[next].dataset.view,true)}},{signal});
    });
    this.querySelectorAll('[data-day]').forEach(button=>button.addEventListener('click',()=>this.setDay(Number(button.dataset.day),true),{signal}));
    this.querySelector('[data-replay]').addEventListener('click',()=>this.reveal(),{signal});
    this.motion.addEventListener('change',()=>{this.stop();this.renderDay(this.day);this.updateReplay()},{signal});
    this.select(this.dataset.initialView==='age'?'age':'nr',false);this.dataset.ready='true';this.updateReplay();
    if('IntersectionObserver' in window){this.observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){this.reveal();this.observer.disconnect()}},{threshold:.2});this.observer.observe(this.querySelector('.v3-nad-card'))}
  }
  disconnectedCallback(){this.stop();this.observer?.disconnect();this.controller?.abort();this.controller=null;delete this.dataset.ready}
  enabled(){return this.dataset.motion==='true'&&!this.motion.matches}
  updateReplay(){this.querySelector('[data-replay]').hidden=!this.enabled()}
  stop(){this.animations.forEach(animation=>animation.cancel());this.animations=[];if(this.frame!==null)cancelAnimationFrame(this.frame);this.frame=null}
  select(view,animate){
    this.stop();this.view=view;
    this.tabs.forEach(tab=>{const selected=tab.dataset.view===view;tab.setAttribute('aria-selected',String(selected));tab.tabIndex=selected?0:-1});
    this.panels.forEach(panel=>{panel.hidden=panel.dataset.panel!==view});
    this.setDay(this.day,false);if(animate)this.reveal();
  }
  setDay(day,animate){
    this.stop();const from=this.displayDay??this.day;this.day=day;
    this.querySelectorAll('[data-day]').forEach(button=>button.setAttribute('aria-pressed',String(Number(button.dataset.day)===day)));
    this.querySelectorAll('[data-result]').forEach(result=>{result.hidden=Number(result.dataset.result)!==day});
    if(!animate||!this.enabled()){this.renderDay(day);return}
    const start=performance.now();const step=now=>{const progress=Math.min(1,(now-start)/850);const eased=1-Math.pow(1-progress,3);this.renderDay(from+(day-from)*eased);if(progress<1)this.frame=requestAnimationFrame(step);else this.frame=null};this.frame=requestAnimationFrame(step);
  }
  renderDay(day){
    this.displayDay=day;const x=36+648*day/56;const nr=this.querySelector('.v3-nad-nr-line');const placebo=this.querySelector('.v3-nad-placebo-line');
    const pointAtX=path=>{let low=0,high=path.getTotalLength();for(let i=0;i<15;i++){const middle=(low+high)/2;if(path.getPointAtLength(middle).x<x)low=middle;else high=middle}return path.getPointAtLength((low+high)/2)};
    const nrPoint=pointAtX(nr),placeboPoint=pointAtX(placebo);
    this.querySelector('[data-chart-clip]').setAttribute('width',String(x-28+8));
    this.querySelectorAll('[data-nr-dot]').forEach(dot=>{dot.setAttribute('cx',String(nrPoint.x));dot.setAttribute('cy',String(nrPoint.y))});
    const placeboDot=this.querySelector('[data-placebo-dot]');placeboDot.setAttribute('cx',String(placeboPoint.x));placeboDot.setAttribute('cy',String(placeboPoint.y));
    const cursor=this.querySelector('[data-cursor]');cursor.setAttribute('x1',String(x));cursor.setAttribute('x2',String(x));
  }
  reveal(){
    this.stop();if(!this.enabled())return;
    const panel=this.panels.find(item=>!item.hidden);
    const animation=panel.animate([{opacity:.55,transform:'translateY(7px)'},{opacity:1,transform:'translateY(0)'}],{duration:480,easing:'cubic-bezier(.2,.7,.2,1)'});this.animations.push(animation);
    if(this.view==='nr'){
      const target=this.day;this.renderDay(0);const start=performance.now();const step=now=>{const progress=Math.min(1,(now-start)/1850);const eased=1-Math.pow(1-progress,2);this.renderDay(target*eased);if(progress<1)this.frame=requestAnimationFrame(step);else this.frame=null};this.frame=requestAnimationFrame(step);
    }else{
      const line=panel.querySelector('.v3-nad-age-line');this.animations.push(line.animate([{strokeDasharray:'1',strokeDashoffset:'1'},{strokeDasharray:'1',strokeDashoffset:'0'}],{duration:1700,easing:'cubic-bezier(.2,.7,.2,1)'}));
      this.animations.push(panel.querySelector('.v3-nad-area').animate([{opacity:0},{opacity:1}],{duration:1900,easing:'ease-out'}));
    }
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["v3-product-gallery"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('arte-product-gallery'))customElements.define('arte-product-gallery',class extends HTMLElement{
  connectedCallback(){
    if(this.ready)return;
    this.ready=true;this.index=0;this.request=0;
    this.thumbs=[...this.querySelectorAll('[data-gallery-thumb]')];
    this.slides=[...this.querySelectorAll('[data-gallery-slide]')];
    this.counter=this.querySelector('[data-gallery-counter]');
    this.querySelector('.arte-gallery-navigation').hidden=false;
    this.thumbs.forEach((button,index)=>{
      button.addEventListener('click',()=>this.show(index));
      button.addEventListener('keydown',event=>{
        let next=index;
        if(event.key==='ArrowRight'||event.key==='ArrowDown')next++;
        else if(event.key==='ArrowLeft'||event.key==='ArrowUp')next--;
        else if(event.key==='Home')next=0;
        else if(event.key==='End')next=this.slides.length-1;
        else return;
        event.preventDefault();next=(next+this.slides.length)%this.slides.length;
        this.thumbs[next].focus();this.show(next);
      });
    });
    this.querySelectorAll('[data-gallery-direction]').forEach(button=>button.addEventListener('click',()=>this.show(this.index+Number(button.dataset.galleryDirection))));
    this.querySelectorAll('[data-gallery-zoom]').forEach(button=>button.addEventListener('click',()=>{
      if(this.swiped){this.swiped=false;return}
      const dialog=this.closest('[data-m-product]').querySelector('.m-zoom'),image=button.querySelector('img'),target=dialog.querySelector('img');
      target.src=button.dataset.galleryZoom;target.alt=image.alt;target.width=image.naturalWidth;target.height=image.naturalHeight;
      dialog.showModal();
    }));
    const stage=this.querySelector('.arte-gallery-stage');
    stage.addEventListener('touchstart',event=>{this.startX=event.changedTouches[0].clientX;this.startY=event.changedTouches[0].clientY;this.swiped=false},{passive:true});
    stage.addEventListener('touchend',event=>{
      const x=event.changedTouches[0].clientX-this.startX,y=event.changedTouches[0].clientY-this.startY;
      if(Math.abs(x)>55&&Math.abs(x)>Math.abs(y)*1.4){this.swiped=true;this.show(this.index+(x<0?1:-1));setTimeout(()=>this.swiped=false,500)}
    },{passive:true});
  }
  async show(index){
    const next=(index+this.slides.length)%this.slides.length;
    if(next===this.index)return;
    const token=++this.request,image=this.slides[next].querySelector('img');
    if(image){image.loading='eager';try{await image.decode()}catch{}}
    if(token!==this.request||!this.isConnected)return;
    const previous=this.slides[this.index],target=this.slides[next],focused=previous.contains(document.activeElement);
    previous.hidden=true;target.hidden=false;this.index=next;
    this.thumbs.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===next)));
    this.counter.textContent=String(next+1).padStart(2,'0')+' / '+String(this.slides.length).padStart(2,'0');
    if(focused)this.thumbs[next].focus({preventScroll:true});
    if(!matchMedia('(prefers-reduced-motion:reduce)').matches)target.animate([{opacity:.2,transform:'translateX(7px)'},{opacity:1,transform:'translateX(0)'}],{duration:320,easing:'cubic-bezier(.2,.7,.2,1)'});
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["v3-purchase-details"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('arte-purchase-details'))customElements.define('arte-purchase-details',class extends HTMLElement{
  connectedCallback(){
    if(this.controller)return;
    this.controller=new AbortController();
    this.animations=new Map();
    this.querySelectorAll('details').forEach(detail=>{
      const summary=detail.querySelector('summary');
      summary.addEventListener('click',event=>{
        if(matchMedia('(prefers-reduced-motion:reduce)').matches||!detail.animate)return;
        event.preventDefault();
        const previous=this.animations.get(detail);
        const opening=previous?!previous.opening:!detail.open;
        const start=detail.getBoundingClientRect().height;
        if(previous)previous.animation.cancel();
        detail.style.height='';
        detail.open=true;
        const end=opening?detail.getBoundingClientRect().height:summary.getBoundingClientRect().height+parseFloat(getComputedStyle(detail).borderBottomWidth||'0');
        detail.style.overflow='hidden';
        const animation=detail.animate({height:[`${start}px`,`${end}px`]},{duration:320,easing:'cubic-bezier(.22,.7,.2,1)'});
        this.animations.set(detail,{animation,opening});
        animation.onfinish=()=>{
          detail.open=opening;
          detail.style.overflow='';
          this.animations.delete(detail);
        };
      },{signal:this.controller.signal});
    });
  }
  disconnectedCallback(){
    this.controller?.abort();this.controller=null;
    this.animations?.forEach(({animation},detail)=>{animation.cancel();detail.style.overflow=''});
    this.animations?.clear();
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["v3-shipping"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('arte-shipping-progress'))customElements.define('arte-shipping-progress',class extends HTMLElement{
  connectedCallback(){this.fill=this.querySelector('.v3-shipping-fill');this.played=false;this.frame=requestAnimationFrame(()=>this.play())}
  disconnectedCallback(){cancelAnimationFrame(this.frame);this.fillMotion?.cancel();clearTimeout(this.celebrationTimer)}
  play(){
    if(this.played||!this.fill||!this.getClientRects().length)return;
    const dialog=this.closest('dialog');if(dialog&&!dialog.open)return;
    this.played=true;
    const to=Math.max(0,Math.min(100,Number(this.dataset.percent)||0)),from=Math.max(0,Math.min(100,Number(this.dataset.from)||0));
    if(matchMedia('(prefers-reduced-motion:reduce)').matches||!this.fill.animate)return;
    this.fillMotion=this.fill.animate([{width:from+'%'},{width:to+'%'}],{duration:from===to?0:700,easing:'cubic-bezier(.22,.68,.25,1)'});
    this.fillMotion.finished.then(()=>{
      if(!this.isConnected||to<100||this.dataset.celebrate==='false')return;
      this.classList.add('is-celebrating');
      this.celebrationTimer=setTimeout(()=>this.classList.remove('is-celebrating'),2400);
    }).catch(()=>{});
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["v3-subscription-options"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('arte-frequency-choice'))customElements.define('arte-frequency-choice',class extends HTMLElement{
  connectedCallback(){
    if(this.controller)return;
    this.controller=new AbortController();
    const signal=this.controller.signal;
    this.select=this.querySelector('select');this.group=this.querySelector('[role="radiogroup"]');
    if(!this.select||!this.group)return;
    const choices=[...this.select.options].filter(option=>option.value).map((option,index)=>{
      const raw=option.dataset.frequencyValue||'',monthly=/\b(month|months|mois|mes|meses|mese|mesi|monat|monate|monaten|maand|maanden|månad|månader)\b/i.test(raw),interval=monthly?Number(raw.match(/\d+/)?.[0]||1):null;
      return {option,interval,order:interval??100+index};
    }).sort((a,b)=>a.order-b.order);
    this.buttons=choices.map(({option,interval})=>{
      const button=document.createElement('button');button.type='button';button.className='v3-frequency-choice';button.setAttribute('role','radio');button.dataset.frequencyChoice=option.value;button.setAttribute('aria-label',option.textContent.trim());
      if(interval){const number=document.createElement('span'),unit=document.createElement('span');number.className='v3-frequency-choice-number';number.textContent=String(interval);unit.className='v3-frequency-choice-unit';unit.textContent=interval===1?this.dataset.monthOne:this.dataset.monthMany;button.append(number,unit)}
      else{button.textContent=option.textContent.trim();button.classList.add('v3-frequency-choice-long')}
      return button;
    });
    if(!this.buttons.length)return;
    this.group.replaceChildren(...this.buttons);this.group.hidden=false;this.querySelector('[data-frequency-native]').hidden=true;
    this.group.addEventListener('click',event=>{const button=event.target.closest('[data-frequency-choice]');if(button)this.choose(button)},{signal});
    this.group.addEventListener('keydown',event=>{
      const button=event.target.closest('[data-frequency-choice]');if(!button||this.select.disabled)return;
      const index=this.buttons.indexOf(button),last=this.buttons.length-1;let next=index;
      if(event.key==='ArrowRight'||event.key==='ArrowDown')next=(index+1)%this.buttons.length;
      else if(event.key==='ArrowLeft'||event.key==='ArrowUp')next=(index+last)%this.buttons.length;
      else if(event.key==='Home')next=0;else if(event.key==='End')next=last;else return;
      event.preventDefault();this.choose(this.buttons[next]);this.buttons[next].focus();
    },{signal});
    this.closest('form').addEventListener('change',()=>this.sync(),{signal});
    this.sync();
  }
  choose(button){if(this.select.disabled||button.disabled)return;this.select.value=button.dataset.frequencyChoice;this.select.dispatchEvent(new Event('change',{bubbles:true}));this.sync()}
  sync(){
    const disabled=this.select.disabled;this.classList.toggle('is-disabled',disabled);this.group.setAttribute('aria-disabled',String(disabled));
    this.buttons.forEach(button=>{const active=button.dataset.frequencyChoice===this.select.value;button.setAttribute('aria-checked',String(active));button.tabIndex=active&&!disabled?0:-1;button.disabled=disabled});
  }
  disconnectedCallback(){this.controller?.abort();this.controller=null}
});
  } catch(e) { console.error(e); }
})();

})();
